// Function loadCountdownTimerBlock loads the CountdownTimerBlock class by dynamically importing the js on demand if needed

export function loadCountdownTimerBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-countdown-timer-block-chunk" */ '../widgets/countdownTimerBlock').then(wg => {

		const { CountdownTimerBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="CountdownTimerBlock"]');

		if(!$wg) {
			// console.info('CountdownTimerBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="CountdownTimerBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new CountdownTimerBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new CountdownTimerBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the CountdownTimerBlock widget');

}
